import React from 'react'
import { styled } from 'styletron-react'
import { padding, margin } from 'lostyle'
import { media, sizes } from '../../style'

const P = styled('p', {
  fontSize: '16px',
  ...padding({
    top: '0',
    right: sizes.spacing.gutter.mobile,
    bottom: '0',
    left: sizes.spacing.gutter.mobile,
  }),
  lineHeight: 1.8,
  ...margin({
    x: 'auto',
    y: sizes.spacing.l,
  }),
  ...media('tablet', {
    fontSize: '18px',
    maxWidth: sizes.blog.maxWidth.desktop,
    ...margin({
      x: 'auto',
      y: sizes.spacing.xl,
    }),
    lineHeight: 1.8,
    ...padding({
      top: '0',
      right: sizes.spacing.gutter.desktop,
      bottom: '0',
      left: sizes.spacing.gutter.desktop,
    }),
  })
})
P.displayName = 'P'

export default P


// WEBPACK FOOTER //
// ./src/components/P/index.js